import type { ListTableGroup, ListTableRow } from 'framework/ui/ui-builder';

export interface CollectionSection {
  id: string | number;
  label: string;
  count?: number;
}

export interface CollectionGrouping<Row extends ListTableRow> {
  getSectionId: (row: Row) => string | number;
}

export const buildCollectionGroups = <Row extends ListTableRow>(
  rows: Row[],
  sections: CollectionSection[],
  getSectionId: (row: Row) => string | number,
): ListTableGroup<Row>[] => {
  const groups = new Map<string | number, ListTableGroup<Row>>(
    sections.map(section => [section.id, { id: section.id, label: section.label, count: section.count, rows: [] }]),
  );

  rows.forEach(row => {
    const sectionId = getSectionId(row);
    const group = groups.get(sectionId);
    if (group) {
      group.rows.push(row);
    } else {
      groups.set(sectionId, { id: sectionId, label: String(sectionId), rows: [row] });
    }
  });

  return [...groups.values()];
};
